export default "__VITE_ASSET__S3hGgnUd__"